

<template>
  <div class="beverage">
   
    <template>
  <div class="beverage__page__breadcrumbs" :style="{backgroundColor:category.color}">
    <router-link to="/">
      <p v-text="$store.getters.pages._.meta_title"  />
      </router-link>
    <router-link :to="beverage.parent.path">
      <p class="breadcrumb__title" v-text="$store.getters.page.parent.title" />
    </router-link>
    <router-link v-if="hasBrandFilter" :to="brandFilterLink">
      <p v-if="hasBrandLabel" class="breadcrumb__title">{{ brandLabel }}</p>
    </router-link>
    <p v-if="beverage.category" class="breadcrumb__title">{{ beverage.category }}</p>
    <p class="breadcrumb__title">{{ beverage.title }}</p>
  </div>
</template>
    <div class="beverage__slider" :style="{backgroundColor:category.color}">
      <div class="beverage__swiper swiper-container" ref="beverageSlider">
        <div class="beverage__wrapper swiper-wrapper">
          <beverage-slide class="beverage__slide swiper-slide" v-for="(beverage, b, i) in beverages"
            :key="b" :class="{'is-single':!hasRelated}" :beverage="beverage"
            :category="category" :swiper="swiper" :i="i" />
        </div>
      </div>
      <div class="beverage__nav beverage__nav--prev"></div>
      <div class="beverage__nav beverage__nav--next"></div>
    </div>
    
          
    <related-beverages v-if="hasRelated" class="beverage__related"
      :beverages="beverages" @goToBeverage="getPathBySlug" />
  
  </div>
</template>

<script>
import page from '@/mixins/page'
import ifDefined from '@/tools/ifDefined'

import RelatedBeverages from '@/components/RelatedBeverages'
import BeverageSlide from '@/components/BeverageSlide'

import Swiper from 'swiper/dist/js/swiper.js'

import anime from 'animejs'

import {mapGetters} from 'vuex'

export default {
  mixins: [page],
  components: {
    BeverageSlide,
    RelatedBeverages
  },
  name: 'BeverageTemplate',
  data() {
    return {
      category: {},
      beverages: {},
      brandBreadcrumb: '',
      isChanging: false,
      swiper: null,
      speed: 600
    }
  },
  computed: {
    console: () => console,
    ...mapGetters(['baseURL', 'nav', 'mobNav', 'device', 'navOpen', 'ui', 'lang']),
    hasRelated() {
      return Object.keys(this.beverages).length > 1
    },
    beverage() {
      const pageIndex = Object.keys(this.beverages).indexOf(this.page.slug)
      return Object.values(this.beverages)[pageIndex] || {}
    },
    hasBrandFilter() {
      return Object.keys(this.beverage.parent.filters).length > 0
    },
    brandFilterLink() {
      return `${this.beverage.parent.path}/${this.beverage.filters.brand}`
    },
    hasBrandLabel() {
      return this.beverage.parent.filters.brand.values[this.beverage.filters.brand]
    },
    brandLabel() {
      return this.beverage.parent.filters.brand.values[this.beverage.filters.brand].label
    }
  },
  methods: {
    getPathByIndex(i) {
      if (ifDefined(Object.keys(this.beverages)[i])) {
        var brand = this.beverages[Object.keys(this.beverages)[i]].filters.brand
        var path
        if (brand) {
          path = '/' + this.category['slug'] + '/' + brand + '/' + Object.keys(this.beverages)[i]
        } else {
          path = '/' + this.category['slug'] + '/' + Object.keys(this.beverages)[i]
        }
        this.$router.push({path})
      }
    },
    getPathBySlug(beverage) {
      var path
      if (beverage.filters.brand) {
        path = '/' + this.category.slug + '/' + beverage.filters.brand + '/' + beverage.slug
      } else {
        path = '/' + this.category.slug + '/' + beverage.slug
      }
      this.$router.push({ path })
    },
    initBeverageSwiper() {
      var e = this.$store.getters.device.isIE ? 'slide' : 'coverflow'
      this.swiper = new Swiper(this.$refs['beverageSlider'], {
        speed: this.speed,
        initialSlide: Object.keys(this.beverages).indexOf(this.page.slug),
        wrapperClass: 'beverage__wrapper',
        slideClass: 'beverage__slide',
        slideActiveClass: 'is-active',
        slideDuplicatedActiveClass: 'is-duplicate',
        slideDuplicateClass: 'is-duplicate',
        slideVisibleClass: 'is-visible',
        slideNextClass: 'is-next',
        slideDuplicatedNextClass: 'is-next',
        slidePrevClass: 'is-prev',
        slideDuplicatedPrevClass: 'is-prev',
        slidesPerView: 1,
        effect: e,
        autoHeight: true,
        observer: true,
        observeParents: true,
        coverflowEffect: {
          rotate: 0,
          depth: 300,
          stretch: 0,
          modifier: 1,
          slideShadows: false
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.beverage__nav--next',
          prevEl: '.beverage__nav--prev',
          disabledClass: 'is-disabled',
          hiddenClass: 'is-hidden'
        },
        on: {
          init: () => {
            this.$forceUpdate()
          },
          slidePrevTransitionStart: () => {
            if (ifDefined(this.swiper) && !this.isChanging) {
              // var index = this.swiper.isBeginning
              //   ? this.swiper.slides.length - 3
              //   : this.swiper.activeIndex - 1
              this.getPathByIndex(this.swiper.activeIndex)
            }
          },
          slideNextTransitionStart: () => {
            if (ifDefined(this.swiper) && !this.isChanging) {
              // var index = this.swiper.isEnd ? 0 : this.swiper.activeIndex - 1
              this.getPathByIndex(this.swiper.activeIndex)
            }
          },
          transitionEnd: () => {
            this.isChanging = false
          }
        }
      })
    }
  },
  watch: {
    $route(to) {
      if (ifDefined(this.swiper) && !this.isChanging) {
        if (this.category['slug'] !== to.meta.parent['slug']) {
          this.category = to.meta.parent
          this.beverages = to.meta.parent.beverages
          this.swiper.destroy()
          if (this.hasRelated) {
            setTimeout(() => {
              this.initBeverageSwiper()
              this.$forceUpdate()
            }, 0)
          }
        } else {
          this.swiper.slideTo(
            Object.keys(this.beverages).indexOf(to.name),
            this.speed,
            false
          )
        }
        anime({
          duration: 600,
          targets: '[data-page]',
          easing: 'easeOutSine',
          scrollTop: 0
        })
      }
    }
  },
  beforeMount() {
    this.category = this.page.parent
    Object.values(this.category.beverages).forEach(beverage => {
      if (beverage.deleted === 1) {
        delete this.category.beverages[beverage.slug]
      }
    })

    this.beverages = this.category.beverages
  },
  mounted() {
    if (this.hasRelated) {
      this.initBeverageSwiper()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/BeverageTemplate.vue